import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Eyebrow, GoldButton } from "@/components/site/motion";
import { useSEO } from "@/hooks/useSEO";

function formatDetail(detail) {
  if (detail == null) return "Login failed. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

const inputCls =
  "w-full border-b border-ink/20 bg-transparent py-3 text-sm text-ink placeholder:text-smoke focus:border-gold focus:outline-none transition-colors duration-300";

export default function AdminLogin() {
  useSEO("Admin Login — Hapo Group", "Sign in to view Hapo Group website enquiries and subscribers.");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      const { data } = await api.login(email, password);
      localStorage.setItem("hapo_admin_token", data.token);
      navigate("/admin");
    } catch (err) {
      setError(formatDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="flex min-h-screen items-center justify-center bg-mist px-6 pt-20" data-testid="admin-login-page">
      <div className="w-full max-w-md border border-ink/10 bg-white p-10">
        <Eyebrow>Admin</Eyebrow>
        <h1 className="mt-4 text-3xl font-extrabold tracking-tighter text-ink">Sign in</h1>
        <form onSubmit={submit} className="mt-8 space-y-7" data-testid="admin-login-form">
          <label className="block">
            <span className="text-[10px] font-bold uppercase tracking-[0.22em] text-smoke">Email</span>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="admin-email-input"
              className={inputCls}
              placeholder="admin@hapogroup.co.za"
            />
          </label>
          <label className="block">
            <span className="text-[10px] font-bold uppercase tracking-[0.22em] text-smoke">Password</span>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="admin-password-input"
              className={inputCls}
              placeholder="••••••••"
            />
          </label>
          {error && (
            <p data-testid="admin-login-error" className="text-sm font-semibold text-red-600">
              {error}
            </p>
          )}
          <GoldButton type="submit" testId="admin-login-submit">
            {loading ? "Signing in..." : "Sign In"}
          </GoldButton>
        </form>
      </div>
    </section>
  );
}
